/* eslint-disable no-use-before-define */
import React from 'react';
import  ReactDropDownAutoComplete  from 'react-dropdown-autocomplete';
import { getlanguagelist } from "../../helpers/changelanguage";
import './common.css';
import $ from "jquery";


export default function ProfileCategoryDropdown(prop) {
  let  languagelist    = getlanguagelist();
  $( "#category_name" ).focus(function() {
    console.log( "Handler for .focus() called." );
    //renderItem()
  });
    const editFields = {name:'Aunt'};
    const dataList = prop.dataList;
    const onchange = (vall) => {
    let matchedIndex = dataList.map(function (obj) { return obj.category_name; }).indexOf(vall);
      if(matchedIndex >= 0){
          let newObj = {
              id    : dataList[matchedIndex].id,
              name :  vall
          }
          prop.changeHandeler(newObj);
      }
    }

    const clearVal =()=>{
      document.getElementById('category_name').value = ''
      let newObj = {
        id    : null,
        name : null
       }
      prop.changeHandeler(newObj);
    }
   

  return (
    <ReactDropDownAutoComplete
        getItemValue={item => item.category_name}
        className="form-control"
        id="category_name"
        name="category_name"
        placeholder={`${languagelist.search} ${prop.addmoreTitle}`}
        data={dataList || []}
        renderItem={(item, isHighlighted) =>
          <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
            {item.category_name}
          </div>}
        icon="ban"
        iconColor="#ec5555"
        iconClick={() => clearVal()}
        value={prop.defaultVal}
        onChange={(val) => onchange(val)}
        onEnter={() => { /* TODO */ }}
      />
  );
}

